import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1e1e28",
        secondary: "#00c2f3",
        accent: "e0e0e0",
        error: "f44336",
        warning: "#44d9ff",
        info: "#2196f3",
        success: "#4caf50"
      }
    }
  }
});
